module.exports = __webpack_public_path__ + "img/checked-true-sm.eeeb4da5.svg";